import racingConfig from './racing/config';
import footballConfig, { footballPlayerConfig } from './football/config';

const sportTypeConfigs = {
    racing: racingConfig,
    football: footballConfig
};

// eslint-disable-next-line import/prefer-default-export
export const getSportTypeConfig = (sportType, isPlayerBased = false) => {
    if (sportType === 'football' && isPlayerBased) {
        return footballPlayerConfig;
    }
    return sportTypeConfigs[sportType] ?? racingConfig;
};
